import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { NativeEventSource, EventSourcePolyfill } from 'event-source-polyfill';

import { IApprovalRequest, EntityId, createRequestOption, IMyRequest, IApprovalRequestSummary, IApprovalRequestExport } from '@appshared';
import { OAuthService } from 'angular-oauth2-oidc';
import * as moment from 'moment';
import { Moment } from 'moment';

@Injectable({
  providedIn: 'root',
})
export class ApprovalRequestApiService {
  protected resourceUrl = '/hrm-portal-api/api/approvals/';

  private _tempEventSources: object = {};
  incomingRequestEvent: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor(
    public _http: HttpClient,
    private _zone: NgZone,
    private _oauthSrv: OAuthService
  ) {}

  query(req?: any): Observable<any> {
    const options = createRequestOption(req);
    return this._http.get<IApprovalRequest[] | IMyRequest[]>(this.resourceUrl, { params: options });
  }

  find(id: EntityId): Observable<any> {
    return this._http.get<IApprovalRequest>(`${this.resourceUrl}${id}`);
  }

  save(data: object): Observable<any> {
    return this._http.post<IApprovalRequest>(this.resourceUrl, data);
  }

  updateStatus(ids: EntityId[], action: string, reason?:string): Observable<any> {
    return this._http.put<any[]>(`${this.resourceUrl}statuses`, { approvalIds: ids, action: action, reason: reason });
  }

  getApprovalRequestSummary(req?: any): Observable<any> {
    const options = createRequestOption(req);
    return this._http.get<IApprovalRequestSummary>(`${this.resourceUrl}summary`, { params: options });
  }

  closeAllEventSourceConnection(): void {
    Object.keys(this._tempEventSources).forEach((key: string) => {
      const eventSource = this._tempEventSources[key];
      if (eventSource && eventSource.listener) {
        eventSource.listener.close();
      }
    });
  }

  countNumberOfApprovalRequest(type: string): Observable<any> {
    return Observable.create(
      observer => {
        if (this._tempEventSources[type]) {
          this._tempEventSources[type].listener.close();
        }

        const source = new EventSourcePolyfill(`${this.resourceUrl}pending-approval-total?queryType=${type}`, {
          headers: {
            'Authorization': 'Bearer ' + this._oauthSrv.getAccessToken()
          }
        });

        this._tempEventSources[type] = {
          listener: source
        };

        source.onmessage = event => {
          this._zone.run(() => {
            observer.next(event.data);
          });
        };
        source.onerror = event => {
          this._zone.run(() => {
            observer.error(event);
          });
        };
      }
    );
  }

  calculateDayOff(startDate: Moment, endDate: Moment): Observable<any> {
    return this._http.post<any>(`${this.resourceUrl}calculate-day-off`, {startDate: startDate, endDate: endDate});
  }

  exportData(body: IApprovalRequestExport): Observable<HttpResponse<Blob>> {
    return this._http.put(`${this.resourceUrl}export`, body, {responseType: 'blob', observe: "response"});
  }
}
